import React from 'react';
import styled from 'styled-components'

import { RatingStars } from './';

import emptyAvatarImg from '../../assets/avatar.svg';

const Wrapper = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    margin: 0 25px;
`

const Image = styled.img`
    width: 75px;
    height: 75px;
`

const Name = styled.span`
    font-size: 11px;
    color: ${props => props.theme.colors.secondary};
    margin: 15px 0;
`

const Date = styled.span`
    font-size: 10px;
    font-style: italic;
    color: ${props => props.theme.colors.textPrimary};
    margin-top: 7px;
`

const Text = styled.span`
    font-size: 12px;
    font-style: italic;
    color: ${props => props.theme.colors.textPrimary};
    max-width: 180px;
    flex-grow: 1;
    margin-top: 12px;
`

export const RatingCell = ({picture, name, score, date, text}) => (
    <Wrapper>
        <Image src={picture || emptyAvatarImg} alt={name} />
        <Name>{name}</Name>
        <RatingStars score={score} />
        <Date>{date}</Date>
        <Text>{text}</Text>
    </Wrapper>
)

